import React from 'react';
import PropTypes from 'prop-types';

import CourseCardMinimal from 'containers/CourseCardMinimal';

import './index.scss';

/**
 * Presentational: one section (header) per sub-category, with a grid of
 * CourseCardMinimal per section. Shared by the direct-category structured
 * view and the product accordion's expanded panel.
 */
export const StructuredCourseSections = ({ subCategories }) => (
  <div className="structured-course-sections">
    {(subCategories || []).map((subCategory) => (
      <div key={subCategory.title} className="structured-course-view-section">
        <h3 className="structured-course-view-section-title">{subCategory.title}</h3>
        <div className="structured-course-view-section-grid d-flex flex-wrap">
          {(subCategory.courses || []).map((course) => (
            <CourseCardMinimal
              key={course.course_id}
              courseId={course.course_id}
              isActive={course.is_active}
              accessType={course.access_type}
              title={course.title}
              bannerImageUrl={course.banner_image_url}
              courseHomeUrl={course.course_home_url}
            />
          ))}
        </div>
      </div>
    ))}
  </div>
);

StructuredCourseSections.propTypes = {
  subCategories: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    courses: PropTypes.arrayOf(PropTypes.object),
  })),
};

StructuredCourseSections.defaultProps = {
  subCategories: [],
};

export default StructuredCourseSections;
